import { render } from "./AddParent.vue?vue&type=template&id=1fed6b94&ts=true"
import script from "./AddParent.vue?vue&type=script&lang=ts"
export * from "./AddParent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__